import { render, staticRenderFns } from "./switchissuemethod.vue?vue&type=template&id=b939d02c&scoped=true"
import script from "./switchissuemethod.vue?vue&type=script&lang=js"
export * from "./switchissuemethod.vue?vue&type=script&lang=js"
import style0 from "./switchissuemethod.vue?vue&type=style&index=0&id=b939d02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b939d02c",
  null
  
)

export default component.exports